import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AddButton, MultipleSelect, SelectTypeAutocomplete } from 'components';
import { PermissionsList, RolePermission, SavePage } from 'utils';
import { CarrierCsvFile } from '../../../components/buttons/carrierCsvFile';
import { vendorStatusesEnum, vendorTypes } from './constants';
import { carrierStatuses, carrierStatusesNoPending, vendorEnums, VendorTables } from '../constants';
import { officeActions } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@material-ui/core';

export const VendorTypesAndFilters = ({}) => {
  const history = useHistory();
  const { officesList } = useSelector((state) => ({
    officesList: state.offices.officesList,
  }));
  const info = history?.location?.state;
  const currentTab = VendorTables(info?.vendorType);
  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      status: 'ACTIVE',
    };
    dispatch(officeActions.getOffices(params));
  }, []);

  const selectType = (item, name) => {
    const params = {
      ...info,
    };

    params.limit = 100;
    params.skip = 0;
    params.page = 1;

    params[name] = item;

    if (item) {
      params[name] = item;
    } else {
      delete params[name];
    }

    if (name === 'vendorType') {

      delete params.highwayOnboard;

      if (item === vendorEnums?.CARRIER) {
        params.statuses = [vendorStatusesEnum[0], vendorStatusesEnum[2]];
      } else {
        params.statuses = [vendorStatusesEnum[0]];
      }
    }
    SavePage(history, info, { ...params });
  };

  const renderActive = (item) => {
    if (item?.id === info?.vendorType) {
      return 'selected';
    } else if (!info?.vendorType && item?.id === vendorEnums?.CARRIER) {
      return 'selected';
    } else {
      return 'not-selected';
    }
  };

  const pushPageDetails = () => {
    history.push({
      pathname: `/create-vendor`,
      state: { vendorType: currentTab?.type },
    });
  };

  return (
    <div className='vendor-types-filters-wrapper'>
      <div className='vendor-types-wrapper'>
        <div className='vendor-types-box'>
          {vendorTypes.map((item, index) => (
            <button
              onClick={() => selectType(item?.id, 'vendorType')}
              className={`vendor-type-btn ${renderActive(item)}`}
              key={index}
            >
              {item?.name}
            </button>
          ))}
        </div>
      </div>
      <div className='vendor-action-box'>
        <div className='space-between'>
          <div className='flex-align-center' style={{ gap: 16 }}>
            <MultipleSelect
              selectedList={
                info?.statuses ? info?.statuses :
                  currentTab?.type === vendorEnums?.CARRIER ?
                    [vendorStatusesEnum[0], vendorStatusesEnum[2]]
                    :
                    [vendorStatusesEnum[0]]
              }
              handleChange={(value) => selectType(value, 'statuses')}
              permissionsList={currentTab?.type === vendorEnums?.CARRIER ? carrierStatuses : carrierStatusesNoPending}
              label={'Select Status'}
              renderName={(item) => item?.name}
              smallSize={true}
            />

            {info?.vendorType !== vendorEnums?.FACTORED &&
              <SelectTypeAutocomplete
                wrapperStyle={{ width: '228px' }}
                placeholder={'Assigned Office'}
                defaultValue={info?.office}
                handleSelect={(e) => selectType(e.target.value, 'office')}
                list={officesList?.offices || []}
                name={'office'}
                custom={(item) => item?.name}
                uiType
                right='0'
              />
            }

            {(info?.vendorType === vendorEnums?.CARRIER || !info?.vendorType)  &&
              <div className='flex-align-center' style={{gap: 8}}>
                <Checkbox
                  onClick={() => {
                    const params = {
                      ...info,
                    }
                    params.statuses = [];
                    params.highwayOnboard = !info?.highwayOnboard;
                    SavePage(history, info, params);
                  }}
                  name={'highwayOnboard'}
                  style={{ color: '#438AFE', padding: 0 }}
                  checked={info?.highwayOnboard}
                />
                <p>Highway onboarding</p>
              </div>
            }

          </div>

          <div>
            <div className='align-center' style={{ gap: '24px', alignItems: 'center' }}>
              {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.EXPORT_CARRIER_CSV?.code]) && currentTab?.vendorCsv &&
                <CarrierCsvFile params={currentTab?.vendorCsv} />
              }
              {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) &&
                <AddButton handleClick={pushPageDetails}
                           href={'/create-vendor'} text={`Add ${currentTab?.title}`} />
              }
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};